import { Button, Container } from '@mantine/core';
import classes from './DebugPage.module.css';
import { AfternoonLoader } from 'src/common/components/loader/AfternoonLoader';

export const DebugPage = () => {
  const callErrorEndpoint = async () => {
    await fetch('http://localhost:8000/paco');
  };

  return (
    <Container className={classes.container} size="responsive" bg={'orange.1'}>
      <AfternoonLoader />
      <Button onClick={callErrorEndpoint}>Call endpoint</Button>
    </Container>
  );
};
